import { Injectable } from '@angular/core';
import { Router, GuardsCheckStart, GuardsCheckEnd, NavigationCancel } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GuardEventObserver {
  private loadingState = new BehaviorSubject<boolean>(false);

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof GuardsCheckStart) {
        this.loadingState.next(true);
      }
      if (event instanceof GuardsCheckEnd || event instanceof NavigationCancel) {
        this.loadingState.next(false);
      }
    });
  }

  getLoadingState(): BehaviorSubject<boolean> {
    return this.loadingState;
  }
}
